/**
 * Hashes an email address using SHA-256, matching MySQL's UNHEX(SHA2(LOWER(Email), 256))
 * @param email The email address to hash
 * @returns The hashed email as a hex string
 */
export const hashEmail = async (email: string): Promise<string> => {
  if (!email) return '';

  const lowerEmail = email.toLowerCase();
  const data = new TextEncoder().encode(lowerEmail);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0')) // Ensure 2-digit hex values
    .join('');
};
